export default __webpack_public_path__ + "static/heroSectionBg-6c0fd364bb85ece7a2e011d21d77450e.webp";